import React from "react";
import styled from "styled-components/macro";
import { NavLink } from "react-router-dom";

import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import {
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
  Box
} from "@material-ui/core";

import { spacing } from "@material-ui/system";
import { UserInformation } from "./settings-forms/user-information";
import { CompanyInformation } from "./settings-forms/company-information";

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);


function SettingsPage() {
  const { t } = useTranslation();
  return (
    <Box p={12} overflow="scroll">
      <Helmet title={t("settingsPage_pageTitle")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("settingsPage_pageTitle")}
      </Typography>

      <Divider mt={6} mb={1}/>

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <CompanyInformation />
          <UserInformation />
        </Grid>
      </Grid>
    </Box>
  );
}

export default SettingsPage;
